import React from "react";

import {Typography} from "../../../../designSystem/components/Typography";
import {Paragraph} from "../../../../designSystem/components/Paragraph";
import {GoBackNavigationIconButton} from "../../../../widgets/GoBackNavigationIconButton";

export const UserUsageTermsFeature = () => (
  <div className="p-8 flex flex-col gap-y-6">
    {/* Go back button */}
    <div className="self-start">
      <GoBackNavigationIconButton />
    </div>

    {/* Title */}
    <div className="flex flex-col gap-y-4">
      <Typography variant="title" align="center">
        屏東遠距醫療諮詢
      </Typography>
      <Typography variant="title" align="center">
        個人資料使用授權
      </Typography>
    </div>

    {/* Content */}
    <div>
      <Paragraph
        text="一、屏東縣政府衛生局為辦理相關業務，並確保申請人員之共同利益，將遵循個人資料保護法及相關法令之規定，蒐集、處理及利用申請人所提供之個人資料，包括E-mail帳號、姓名、出生日期、身分證字號、服務機構、通訊住址、電話等資訊。"/>
      <Paragraph
        text="二、申請人員就其個人資料得依個人資料保護法第三條之規定，行使：查詢或請求閱覽、請求製給複製本、補充或更正、停止蒐集、處理、利用與刪除等權利。"/>
      <Paragraph
        text="三、申請人員得自由選擇是否提供個人資料或行使個人資料保護法第三條所定之權利，但申請人員提供資料不足或有其他冒用、盜用、不實之情形，可能將無法參加相關服務及影響各項相關權益。"/>
      <Paragraph
        text="四、依個人資料保護法第三條之規定，請人員請求停止蒐集、處理或利用或請求刪除前，本部得依循個人資料保護法及相關法令之規定，於個人資料提供之範圍與目的內使用該等個人資料。"/>
      <Paragraph
        text="五、申請人員瞭解此一條款符合個人資料保護法及相關法規之要求，且同意本部 留存本同意書，供日後取出查驗。"/>
      <Paragraph text="六、本局因業務需要而委託其他機關處理申請人的個人資料時，將會善盡監督之責。"/>
    </div>
  </div>
)